module.exports = __webpack_public_path__ + "static/media/MinnieGaryCover.f370a239.jpg";